import { ErrorHandler, Injectable, inject } from '@angular/core';

import { TelemetryService } from './telemetry.service';

/**
 * MOB-100 Stage 28 — Angular `ErrorHandler` that forwards every uncaught
 * exception through `TelemetryService.captureException(...)`.
 *
 * Two consumers feed into this handler:
 *   1. `provideBrowserGlobalErrorListeners()` — already registered in
 *      `app.config.ts` (Stage 17). It wires the global `error` and
 *      `unhandledrejection` listeners into Angular's error machinery so
 *      they end up here too.
 *   2. RxJS observable streams that re-throw — Angular catches and
 *      forwards them here.
 *
 * We deliberately ALSO log to the console: in dev the engineer still
 * needs the stack-trace, and in prod Sentry already de-duplicates.
 */
@Injectable({ providedIn: 'root' })
export class TelemetryErrorHandler implements ErrorHandler {
  private readonly telemetry = inject(TelemetryService);

  handleError(error: unknown): void {
    try {
      this.telemetry.captureException(error, {
        source: 'angular-error-handler'
      });
    } catch {
      /* never let telemetry crash the error path */
    }
    if (typeof console !== 'undefined') {
      console.error('[telemetry-error-handler]', error);
    }
  }
}
